import { useState, useEffect } from 'react';

import Slider from '@mui/material/Slider';
import LinearProgress from '@mui/material/LinearProgress';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import useWindowDimensions from '../Hooks/useWindowDimensions';

const TextAnswer = (props) => {

  const { windowWidth } = useWindowDimensions();
  const [textAnswer, setTextAnswer]   = useState(props?.question?.answerTxt);
  const updateTextAnswer = props?.updateTextAnswer;

  useEffect(() => {
      updateTextAnswer(props?.question?.id, textAnswer);
  }, [textAnswer]);
  
  useEffect(() => {
    if(props?.question?.answerTxt) setTextAnswer(props?.question?.answerTxt);
    else setTextAnswer("");
  }, [props?.question?.answerTxt]);

  return <TextField hiddenLabel multiline rows={windowWidth > 650 ? 4 : 5} placeholder="Please type your response here" value={textAnswer} onChange={(e) => setTextAnswer(e.target.value)} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="form-details-text" />

}

const Question = props => {

  console.log("Question props", props);

  const [showSlider, setShowSlider]   = useState(false);
  const [sliderWidth, setSliderWidth] = useState(90);
  const [maxWidth, setMaxWidth]       = useState(props.question?.answers?.length);
  const [runTimeoutFunc, setRunTimeoutFunc] = useState(false);
  const [selectedOption, setSelectedOption] = useState({});
  const [sliderProgress, setSliderProgress] = useState(props.question?.answers?.find(ans => ans.value == props.question?.answer)?.order_no || 0);
  const [answerValue, setAnswerValue] = useState(props.question?.answer || 0);

  useEffect(() => {
    if (runTimeoutFunc) {
      const timer = setTimeout(() => {
        if (answerValue == 0 || !props.question.answer) {
          setShowSlider(false);
        }
      }, 500);
      return () => {
        setRunTimeoutFunc(false)
        clearTimeout(timer);
      }
    }

  }, [props.question.answer, runTimeoutFunc, answerValue]);

  useEffect(() => {
    if ((props.question?.answer == 0 || !props.question?.answer) && !sliderProgress) {
      setShowSlider(false);
    }
    else if (props.question.answer > 0 || sliderProgress > 0) {
      const selectedOption = props.question?.answers?.find(ans => ans.value == props.question?.answer);
      setSelectedOption(selectedOption);
      setShowSlider(true);
    }
  }, [props.question.answer, props.question?.answers, sliderProgress]);

  useEffect(() => {
    if (props?.question?.answer == 0) setSliderProgress(0);
    else if (props?.question?.answer > 0) {
      setSliderProgress(selectedOption?.order_no);
    }
  }, [props, props.question.answer, selectedOption]);

  useEffect(() => {
    switch (props.question?.answers?.length) {
      case 2: setSliderWidth(36); break;
      case 3: setSliderWidth(56); break;
      case 4: setSliderWidth(76); break;
      case 5: setSliderWidth(85); break;
      case 6: setSliderWidth(90); break;
      default: break;
    }

    setMaxWidth(props.question?.answers?.length);

  }, [props, props.question.question, props.question.answer]);

  // console.log("props.question.answer", props.question.answer);
  // console.log("sliderProgress", sliderProgress); console.log("showSlider", showSlider);

  const getLeft = (index) => {
    switch (props.question?.answers?.length) {
      case 2: return index * 80;
      case 3: return index * 40;
      case 4: return index * 27;
      case 5: return index * 20;
      case 6: return index * 16;
      default: return index * 20;
    }
  }
  
  const getLeftRadio = (index) => {
    switch (props.question?.answers?.length) {
      case 2: return index * 80;
      case 3: return index * 40;
      case 4: return index * 27;
      case 5: return index * 6;
      case 6: return index * 4;
      default: return index * 20;
    }
  }

  const getRadioWidth = (answers) => {

    switch (answers) {
      case 3: return {width: "70%", marginLeft: "7.5%"};
        // return { width: "70%" };
      case 5: return {width: "90%", marginLeft: "2.5%"};
      case 6: return {width: "100%", marginLeft: "0%"};
      default: return {width: "50%"};
    }
    // if(answers === 3) { return {width: "70%", marginLeft: "7.5%"}; }
    // return {width: "50%"};
  }

  const radioOptionWidth = (answers) => {
    switch (answers) {
      case 5: return "20%";
      case 6: return "16%";
      default: return "20%";
    }
  }
  
  const updateSliderTextHighlight = (progress) => {
    console.log("progress", progress);
    console.log("desktop_text", props?.question?.answers?.find(ans => ans.value === progress)?.desktop_text);
    let activeSlider = null;
    let sliderText = props?.question?.answers?.find(ans => ans.value === progress)?.desktop_text;
    switch (sliderText?.trim()) {
      case "Strongly Agree": 
        activeSlider = 5; break;
      case "Agree": 
        activeSlider = 4; break;
      case "Neutral": 
        activeSlider = 3; break;
      case "Disagree": 
        activeSlider = 2; break;
      case "Strongly Disagree": 
        activeSlider = 1; break;
      default: 
        activeSlider = progress;
    }
    return activeSlider;
  }

  const updateStep = (dataObj) => {
    // const updateStep = (progressArg) => {
      // setTimeout(() => {setSliderProgress(progressArg)}, 0);
      // props.questionAnswered(progressArg);
    setShowSlider(true);
    setAnswerValue(dataObj.value);
    setTimeout(() => {setSliderProgress(dataObj.order_no)}, 0);
    props.questionAnswered(dataObj.value);
    setRunTimeoutFunc(true);
  }

  const updateRadioStep = (progressArg) => {

    // setSliderProgress(progressArg);
    setTimeout(() => {setSliderProgress(progressArg)}, 0);
    props.questionAnswered(progressArg);
    // setTimeout(() => {
    //   // setSliderProgress(0);
    // }, 500);

  }

  const getLabelStyle = () => {
    if(window.innerWidth > 650) {

      // if(props.question?.answers?.length === 5) {
      //   return { width: "100%", marginLeft: "-50%" };
      // } else if(props.question?.answers?.length === 4) {
      //   return { width: "150%", marginLeft: "-75%" };
      // } else if(props.question?.answers?.length === 3) {
      //   return { width: "200%", marginLeft: "-100%" };
      // } else if(props.question?.answers?.length === 2) {
      //   return { width: "400%", marginLeft: "-200%" };
      // } else {
      //   return { width: "150%", marginLeft: "-75%" };
      // }
      return { width: "12ch", marginLeft: "-6ch" };

    } else {

      if(props.question?.answers?.length === 6) {
        return { width: "9ch", marginLeft: "-4.5ch", wordBreak: "break-all" };}
      // if(props.question?.answers?.length === 5) {
      //   return { width: "120%", marginLeft: "-60%" };
      // } else if(props.question?.answers?.length === 4) {
      //   return { width: "150%", marginLeft: "-75%" };
      // } else if(props.question?.answers?.length === 3) {
      //   return { width: "300%", marginLeft: "-150%" };
      // } else if(props.question?.answers?.length === 2) {
      //   return { width: "500%", marginLeft: "-250%" };
      // } else {
      //   return { width: "150%", marginLeft: "-75%" };
      // }
      else return { width: "10ch", marginLeft: "-5ch" };
    }
    
  }

  const checkOpacity = (index) => {
    if(index === 0 && showSlider) return "0";
    else return "1";
  }

  const checkSelected = (dataObj) => {
    // if(progress === selectedOption?.value) return "label active";
    // else return "label";
    if (dataObj.value == selectedOption?.value) return "label active";
    else return "label";
  }

  const updateQuestion = (event, step) => {
    props.question.answerTxt = event.target.value;
    // setState({answerTxt: event.target.value});
    // props.textAnswer(event.target.value);
    // return true;
  }

    return (
      <div>
        
        <div className={`question ${props.question?.type}`}>
          <p>{props.question?.question}</p>
        </div>

        {
          (() => {
            switch(props.question?.type) {
              
              case "textarea":
                return <>
                  <div className="textarea-field">
                    {/* <TextField hiddenLabel multiline rows={4} placeholder="Please type your response here" value={props.question?.answerTxt} onChange={(e) => {updateQuestion(e, 1)}} fullWidth variant="standard" size="normal" InputProps={{ disableUnderline: true }} className="form-details-text" /> */}
                    <TextAnswer question={props?.question} updateTextAnswer={props?.updateTextAnswer} />
                  </div>
                </>

              case "radio":
                return <>
                  <div className="radio-container">
                    <div className="slider-labels" style={getRadioWidth(props.question?.answers?.length)}>
                      { 
                        props.question?.answers?.map((data, index) => (
                          <div className={checkSelected(data)} key={`labels-${index}`} style={{ left: getLeftRadio(index) + '%', width: radioOptionWidth(props?.question?.answers?.length) }} onClick={() => updateRadioStep(data.value)}>
                          {/* <div className={checkSelected(data.value)} key={`labels-${index}`} style={{ left: getLeft(index) + '%'}} onClick={() => updateStep(data.value)}> */}
                            {/* <FormControlLabel value={data.value} control={<Radio />} label="" /> */}
                            <Radio checked={data.value == sliderProgress} value={sliderProgress} />
                            <p className="desktop" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.desktop_text }}></p>
                            <p className="mobile" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.mobile_text }}></p>
                          </div>
                        ))
                      }
                          {/* { 
                            props.question?.answers.map((data, index) => (
                              <FormControlLabel value={data.value} control={<Radio />} label={data.value} onClick={() => updateStep(data.value)} />
                              // <a className="point" key={`points-${index}`} style={{ left: getLeft(index) + '%', opacity: checkOpacity(index) }}></a>
                            ))
                          } */}
                      
                    </div>
                  </div>
                </>

              default: 
                return <div className="slider-container" style={{ width: sliderWidth + '%' }}>
                  <div className="slider">
                    { showSlider ? <Slider
                      key={props.question?.id}
                      valueLabelDisplay="off"
                      step={1}
                      min={1}
                      max={maxWidth}
                      value={sliderProgress || 0}
                      className="custom-slider"
                    /> : <div className="slider-none-adjust"></div> }
                    <div className="slider-points">
                    { 
                      props.question?.answers?.map((data, index) => (
                        <a className="point" key={`points-${index}`} style={{ left: getLeft(index) + '%', opacity: checkOpacity(index) }} onClick={(e) => updateStep(data)}></a>
                      ))
                    }
                    </div>
                    <LinearProgress className="custom-bar" variant="determinate" value={0} />
                    
                  </div>
                  <div className="slider-labels">
                    { 
                      props.question?.answers?.map((data, index) => {
                        return (
                        <div className={checkSelected(data)} key={`labels-${index}`} style={{ left: getLeft(index) + '%'}} onClick={(e) => updateStep(data)}>
                          <p className="desktop" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.desktop_text }}></p>
                          <p className="mobile" style={getLabelStyle()} dangerouslySetInnerHTML={{ __html: data.mobile_text }}></p>
                        </div>
                      )})
                    }
                  </div>
                </div>
            }
          }).call(this)
        }
  
        {/* <div className="slider-container" style={{ width: state.sliderWidth + '%' }}>
          <div className="slider">
            { state.showSlider ? <Slider
              key={props.question.id}
              valueLabelDisplay="off"
              step={1}
              min={1}
              max={state.maxWidth}
              value={state.progress}
              className="custom-slider"
            /> : <div className="slider-none-adjust"></div> }
            <div className="slider-points">
            {/* { !state.showSlider ? 
              <a className="point" style={{ left: '0%'}} onClick={() => updateStep(1)}></a> : null } */}
              {/* { 
                props.question?.answers.map((data, index) => (
                  <a className="point" key={`points-${index}`} style={{ left: getLeft(index) + '%', opacity: checkOpacity(index) }} onClick={() => updateStep(data.value)}></a>
                ))
              }
            </div>
            <LinearProgress className="custom-bar" variant="determinate" value={0} />
            
          </div>
          <div className="slider-labels">
            { 
              props.question?.answers.map((data, index) => (
                <div className={checkSelected(data.value)} key={`labels-${index}`} style={{ left: getLeft(index) + '%'}} onClick={() => updateStep(data.value)}>
                  <p className="desktop" style={getLabelStyle()} dangerouslySetInnerHTML={{__html: data.desktop_text }}></p>
                  <p className="mobile" style={getLabelStyle()} dangerouslySetInnerHTML={{__html: data.mobile_text }}></p>
                </div>
              ))
            }
          </div>
        </div> */}
  
      </div>
    );
  }
  
export default Question;
